<div class="flex-content-box">
  <nz-radio-group
    [ngModel]="radioValue()"
    (ngModelChange)="radioValue.set($event)"
    nzName="radiogroup"
  >
    <div class="fluid-container" [class.noAssetChosen]="radioValue() === ''">
      @for (item of colorInput(); track item.ColourCodeHex) {
        @if (item.ColourCodeHex) {
          <button
            class="flex-content"
            [class.active]="radioValue() === item.ColourCodeHex"
            [class.white-active]="radioValue() === item.ColourCodeHex"
            (click)="getSelectedColor(item)"
          >
            <span
              class="color-box"
              [style.background-color]="item.ColourCodeHex"
            ></span>

            <label
              nz-radio
              [nzValue]="item.ColourCodeHex"
              (click)="getSelectedColor(item)"
            >
            </label>

            <span class="icon-text body-bold color-text">
              @switch (item.ColourCodeHex) {
                @case ("#B62121") {
                  {{ i18n.langString("color_red") }}
                }
                @case ("#21B630") {
                  {{ i18n.langString("color_green") }}
                }
                @case ("#282828") {
                  {{ i18n.langString("color_black") }}
                }
                @case ("#0E4BE5") {
                  {{ i18n.langString("color_blue") }}
                }
                @default {
                  {{ item.Name }}
                }
              }
            </span>
          </button>
        }
      } @empty {
        <p>No colors available.</p>
      }
    </div>
  </nz-radio-group>
</div>
